import axios from "axios";
import { Box3 } from "three";
import { config } from "../../../config/config";
import { IPointCloudTile, PointCloudTile } from "../PointCloudTile";
import { IBVHLoader, IPointCloudLoadParams } from "./interface";

interface IPointCloudTileRawStruct {
  id: number;
  url: string;
  size: number;
  tileBBox: number[]; // bounding box of tiles
  boundingBox: number[]; //bounding box of points
  children: IPointCloudTileRawStruct[];
}

export class BVHLoader implements IBVHLoader {
  private loadPointCloudBVH(
    rootObj: IPointCloudTileRawStruct
  ): IPointCloudTile {
    const parse = (
      obj: IPointCloudTileRawStruct,
      parent?: IPointCloudTile
    ): IPointCloudTile => {
      const tile = new PointCloudTile(parent);
      tile.id = obj.id;
      tile.url = obj.url;
      tile.size = obj.size;
      tile.tileBBox = new Box3().setFromArray(obj.tileBBox);
      tile.boundingBox = new Box3().setFromArray(obj.boundingBox);

      tile.children = [];
      //   this._flatMapUrlToTile.set(tile.url, tile);
      for (const cobj of obj.children) {
        const parsedTile = parse(cobj, tile);
        if (parsedTile.size > 0) {
          tile.children.push(parsedTile);
        }
      }
      return tile;
    };
    return parse(rootObj);
  }

  async load(
    params: IPointCloudLoadParams,
    abortController: AbortController,
    type?: string,
    projectId?: string,
    timestamp?: string
  ): Promise<{ root: IPointCloudTile; offset: number[] }> {
    let folderName: string;
    if (type === "simple") {
      folderName = "point_cloud_split_upload";
    } else if (type === "sfm") {
      folderName = "point_cloud_split_SfM";
    } else if (type === "helmert") {
      folderName = "point_cloud_split_Helmert";
    }

    let hostName = config.serverHost.includes("localhost")
      ? "http://localhost:9090/quick3d"
      : config.serverHost;
    const url = `${hostName}/project_${projectId}/${folderName}/meta.json?timestamp=${timestamp}`;

    const response = await axios.get(url, {
      // withCredentials: true,
      responseType: "json",
      signal: abortController.signal,
    });
    const jsonData = response.data;
    return {
      root: this.loadPointCloudBVH(jsonData.root as IPointCloudTileRawStruct),
      offset: jsonData.offset || [0, 0, 0],
    };
  }
}
